import { createContext } from "use-context-selector"

import { createProvider } from "domain/createProvider"
import { getDataGridInitState } from "domain/utils"

const initState = getDataGridInitState()

export const PayoutTapOnFeesContext = createContext(initState)

export const PayoutTapOnFeesProvider = createProvider(
  PayoutTapOnFeesContext,
  initState
)
